import { Control, Controller, FormState } from 'react-hook-form';
import { subTitle } from '@/components/streams/stream-invite/invite-users-modal.css.ts';
import { InviteUsersFormData } from '@/components/streams/stream-invite/invite-users-modal.tsx';
import { UsersMultiSelectCombobox } from '@/components/users/users-multi-select-combobox/users-multi-select-combobox';

export const InviteByUsernameModalContent = ({
  control,
  formState,
  maxInvites,
}: {
  control: Control<InviteUsersFormData>;
  formState: FormState<InviteUsersFormData>;
  maxInvites: number;
}) => {
  return (
    <>
      <div className={subTitle}>
        Type name or a username of those who you want to invite to your private
        stream. You can remove them later if you want.
      </div>

      <Controller
        name="users"
        control={control}
        rules={{
          required: 'This field is required',
          validate: (value) => {
            return value.length > maxInvites
              ? `You can only invite up to ${maxInvites} users at a time`
              : true;
          },
        }}
        render={({ field }) => {
          return (
            <UsersMultiSelectCombobox
              selectedUsers={field.value}
              setSelectedUsers={field.onChange}
              error={formState.errors.users?.message}
            />
          );
        }}
      />
    </>
  );
};
